export enum IsbnIllustrationColorEnum {
  BlackAndWhite,
  Color,
  None
}
